import apiConfigs from 'app/configs/apiConfigs'
import { GoogleApiWrapper, Map as GoogleMap, Marker } from 'google-maps-react'
import PropTypes from 'prop-types'
import React from 'react'

const Map = (props) => {
  const {
    center,
    readOnly = true,
    zoom = 15,
    onLocationChange = () => {},
    ...rest
  } = props

  // to do arg. mapProps, map
  const handleClickMap = (_, __, clickEvent) => {
    if (readOnly) return

    onLocationChange({
      lat: clickEvent.latLng.lat(),
      lng: clickEvent.latLng.lng(),
    })
  }

  return (
    <GoogleMap
      google={props.google}
      initialCenter={center}
      center={center}
      zoom={zoom}
      onClick={handleClickMap}
      {...rest}
    >
      <Marker position={center} />
    </GoogleMap>
  )
}

Map.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  zoom: PropTypes.number,
  onLocationChange: PropTypes.func,
}

export default GoogleApiWrapper({
  apiKey: apiConfigs.googleAPI,
})(Map)
